import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(_ctx.classId),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick())),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMouseOver())),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMouseLeave()))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
      return (_openBlock(), _createElementBlock("td", {
        key: column.key
      }, [
        (column.key === 'icon')
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass({ 'icon-apartment': _ctx.ad.estateType === 100, 'icon-house': _ctx.ad.estateType === 200 })
            }, null, 2))
          : (column.key === 'street')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.ad.street) + " " + _toDisplayString(_ctx.ad.streetNumber), 1)
              ], 64))
            : (column.key === 'price')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.ad.price)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.ad.price, _ctx.ad.currency)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.isEstateAgency ? 'price.empty-agency' : 'price.empty')), 1)
                      ], 64))
                ], 64))
              : (column.key === 'pricePerSquareMeter')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (_ctx.ad.pricePerSquareMeter)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.ad.pricePerSquareMeter, _ctx.ad.currency)), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (column.key === 'adType')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createTextVNode(_toDisplayString(_ctx.ad.estateFrontSubTypeTitle), 1)
                    ], 64))
                  : (column.key === 'bedCount')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createTextVNode(_toDisplayString(_ctx.ad.personCount), 1),
                        _hoisted_1,
                        _createElementVNode("span", null, _toDisplayString(_ctx.ad.bedCount), 1)
                      ], 64))
                    : (column.key === 'roomCount')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createTextVNode(_toDisplayString(_ctx.ad.roomCount), 1)
                        ], 64))
                      : (column.key === 'landArea')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            (_ctx.landArea)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.landArea) + " m", 1),
                                  _hoisted_2
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (column.key === 'estateArea')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                              _createTextVNode(_toDisplayString(_ctx.ad.estateArea) + " m", 1),
                              _hoisted_3
                            ], 64))
                          : (column.key === 'createdUtc')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                _createTextVNode(_toDisplayString(_ctx.$filters.timeAgo(_ctx.ad.createdUtc)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 34))
}